<template>
  <img alt="Vue logo" height="75" width="300" src="./assets/logotype.png" />
  <ShowUnit />
</template>

<script>
import ShowUnit from './components/ShowUnit.vue'

export default {
  name: 'App',
  components: {
    ShowUnit
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
